import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { getCategoryMeta } from '@/mocks/categories';
import { formatViews } from '@/utils/articles';

interface HotRankingProps {
  articles: Article[];
}

export default function HotRanking({ articles }: HotRankingProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
      {articles.map((article, i) => {
        const rankColor =
          i === 0
            ? 'bg-accent-500 text-background-50'
            : i === 1
              ? 'bg-primary-500 text-background-50'
              : i === 2
                ? 'bg-primary-300 text-foreground-950'
                : 'bg-background-200 text-foreground-600';
        return (
          <Link
            key={article.id}
            to={`/detail/${article.id}`}
            className="flex items-center gap-4 px-4 md:px-5 py-4 border-b border-background-100 last:border-0 hover:bg-background-100 transition-colors cursor-pointer group"
          >
            <span
              className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center text-sm font-bold ${rankColor}`}
            >
              {i + 1}
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-medium text-sm md:text-base text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <div className="mt-1 flex items-center gap-3 text-xs text-foreground-400">
                <span className="whitespace-nowrap">{getCategoryMeta(article.category)?.name}</span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-fire-line text-accent-500" />
                  {formatViews(article.views)}
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-share-forward-line" />
                  {article.shares}
                </span>
              </div>
            </div>
            <div className="w-16 h-12 md:w-24 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-100 hidden sm:block">
              <img
                src={article.cover}
                alt={article.title}
                title={`${article.title} - 91吃瓜`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
}